import Immutable from 'immutable';

export const OptionState = Immutable.fromJS({
    conform:[],
    reserveDate:[],
    reserveTime:[],
    gender:[{value:"M", label:"男"},{value:"F", label:"女"}],
    city:[],
    AREA_CODE:[],
    vaccine:[],
    loading:false,
    config:[]   
})

export const formDefault = {
    conformId:"",
    VACC_ID:"",
    reserveDate:"",
    reserveTimeId:"",
    PAT_NAME:"",
    PAT_IDNO:"",
    TEL_MOBILE:"",
    EMAIL:"",
    SEX:"",
    BIRTHDAY:null,
    OCC_COMP:"",
    OCC_TITLE:"",
    city:"", 
    AREA_CODE:"",
    ADDRESS:"",
    DOSAGE_COUNT:"1",
    PRE_VACCINE_TYPE:"",
    PRE_VACCINE_DATE:null,
    PRE_VACCINE_REMARK:"",
    loading:false,
    pass: false
}

export const FormState = Immutable.fromJS(formDefault)

export const ResultState =  Immutable.fromJS({
    result:{}
})

export const ReserveHistoryState = Immutable.fromJS({
    search:{
        PAT_IDNO:"",
        TICKET_NO:"",
        TEL_MOBILE:"",
        loading:false
    },
    result:{}
})


